module.exports = __webpack_public_path__ + "img/logo.2ed8156b.png";